import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import Button from '@components/ui/Button'
import Modal from '@components/ui/Modal'
import { useMineInfo } from '@/auth/useMineInfo'
import useCompanyUrl from '@/hooks/useCompanyUrl'
import useSimpleMode from '@/hooks/useSimpleMode'
import { SIMPLE_MODE_ENTRANCE, STATIONARY_COMBUSTION_MANAGEMENT } from '@/routes'
import { useSSOVerify } from '@/sso'
import localStorageUtil from '@/utils/localstorage'
import message from '@/utils/message'

const MicrosoftVerify = () => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const history = useHistory()

  const { isUsedSimpleModeByUser } = useSimpleMode()

  const companyUrl = useCompanyUrl()

  const { refetch: getUserMineInfo } = useMineInfo()

  const [, verify] = useSSOVerify({
    onError: error => {
      console.log(error)
    },
    onSuccess: (response: any) => {
      if (!response) {
        return
      }
      // 跟 login 回傳的一樣
      if (response?.errorMessage) {
        message({ content: response?.errorMessage, type: 'error' })
        return
      }

      localStorageUtil.set('token', response.token)
      // global, admin, company 都使用同一登入頁面，
      // 但不同版面的 style 設定都是由 URL 判斷，故登入後必須在取得 mineInfo 先跳轉到對應的網址
      directToPage(response)
      getUserMineInfo()
    },
  })

  const directToPage = (userInfo: any) => {
    let defaultPage = ''

    if (userInfo?.companyObj) {
      if (isUsedSimpleModeByUser(userInfo)) {
        defaultPage = companyUrl.urlReplacer(SIMPLE_MODE_ENTRANCE, userInfo.companyObj?.companyCode)
      } else {
        defaultPage = companyUrl.urlReplacer(
          STATIONARY_COMBUSTION_MANAGEMENT,
          userInfo.companyObj?.companyCode
        )
      }
    }

    history.push(defaultPage)
  }

  const redirectToLoginURL = () => {
    history.push('/')
  }

  const [isVerifyError, setVerifyError] = React.useState(false)

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)

    const code = params.get('code')

    if (code) {
      verify(
        {
          code,
        },
        {
          onSuccess: (response: any) => {
            setVerifyError(false)
            localStorageUtil.set('token', response.token)
            getUserMineInfo()
          },
          onError: (err: any) => {
            setVerifyError(true)
          },
        }
      )
    } else {
      redirectToLoginURL()
    }
  }, [location]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Modal visible centered footer={null} closable={false}>
        <div className="text-center">
          {isVerifyError ? (
            <>
              <div className="text-danger font-bold text-lg mb-10">{t('verifyFailed')}</div>
              <Button onClick={() => redirectToLoginURL()}>{t('verifyAgain')}</Button>
            </>
          ) : (
            <>
              <Spin />
              <label className="mx-10 font-bold text-lg">{t('verifyInprocess')}</label>
            </>
          )}
        </div>
      </Modal>
    </>
  )
}

export default MicrosoftVerify
